module.exports = __webpack_public_path__ + "img/14-full-md.32024d71.jpg";